import { H } from "../../../Component";

interface GridIconProps { }

export default (props: GridIconProps, tsx: H) => (
    <svg
        height="16px"
        width="16px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
    >
        <path d="M0 0v7h7V0zm6 6H1V1h5zm3-6v7h7V0zm6 6h-5V1h5zM0 9v7h7V9zm6 6H1v-5h5zm3-6v7h7V9zm6 6h-5v-5h5z"/>
    </svg>
);
